module.exports = __webpack_public_path__ + "static/media/verdana.4ba636f1.ttf";